import { Button } from '@material-ui/core'
import classnames from 'classnames'
import * as React from 'react'
import { isMobile } from 'react-device-detect'

import {
  Circle,
  EvaluationWarningModal,
  GameInstallationModal,
  PlusOnlyPopup
} from 'components'
import GameType from 'data/games/gameTypes'
import { _route } from 'routes/config'
import { getDeviceLink } from 'services/downloadApp'
import { getGamesCount } from 'services/games'
import { getQuestionnairesCount } from 'services/questionnaires'
import TourService from 'services/tour'
import { childDashboardNameTransform, getAge } from 'services/utils'

const modalDelay = 1000

import {
  AccuracyFaultModal,
  GameBox,
  Header,
  HeaderDetail,
  ProgressionEvaluationModal
} from 'components'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as PatientActions from 'store/patients/actions'
import './styles.scss'

enum Page {
  thisDevice = 'this-device',
  anotherDevice = 'another-device'
}

export interface IGameInfo {
  type: GameType
  fullCount?: number
  completed?: number
  headerText?: string
  onClick?: () => void
}

interface IReduxStateProps {}

interface IReduxDispatchProps {
  PatientsLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface IProps extends IReduxProps {
  faultGames: GameType[]
  games: IGameInfo[]
  patientId: string
  patientDetail: any
  role: any
  user: any
  history: any
  goBackAction: () => void
  loading: boolean
  instructionFaultGames: GameType[]
  plusUser: any
  isOpenPlusOnlyPopup: boolean
  openPlusOnlyPopup: () => void
  closePlusOnlyPopup: () => void
}

interface IState {
  modalOpen: boolean
  modalShown: boolean
  progressionEvaluationModalOpen: boolean
  gameInstallationModalOpen: boolean
  evaluationWarningModalOpen: boolean
  gamesCompletedModalShown: boolean
  gameInstallationPage: Page
  isAccuracyFaultNotice: boolean
}

class Content extends React.Component<IProps, IState> {
  state: IState = {
    modalOpen: false,
    modalShown: false,
    progressionEvaluationModalOpen: false,
    gameInstallationModalOpen: false,
    evaluationWarningModalOpen: false,
    gamesCompletedModalShown: false,
    gameInstallationPage: Page.thisDevice,
    isAccuracyFaultNotice: true
  }

  handleFaultGames = () => {
    const { faultGames, instructionFaultGames } = this.props
    const { modalShown } = this.state
    const isAccuracyFaultNotice = instructionFaultGames.length ? false : true

    if (
      (faultGames.length || instructionFaultGames.length) &&
      !modalShown &&
      !sessionStorage.getItem('faultGamesShown')
    ) {
      sessionStorage.setItem('faultGamesShown', 'true')
      this.setState({
        modalOpen: true,
        modalShown: true,
        isAccuracyFaultNotice
      })
    }
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.cleanLocationState)
    this.handleFaultGames()

    if (this.props.history.location?.state?.userCameFromQuestionnaires) {
      this.handleUserCameFromQuestionnaires()
    }
  }

  handleUserCameFromQuestionnaires = () => {
    // const { patientDetail } = this.props
    if (isMobile && this.props.user.logged_in_game) {
      // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
      window.open(getDeviceLink())
    } else {
      setTimeout(() => {
        this.setState({
          progressionEvaluationModalOpen: false,
          gameInstallationModalOpen: true
        })
      }, modalDelay)
    }
  }

  componentDidUpdate(prevProps: IProps) {
    // don't show modal if questionnaires were already finished
    if (
      getGamesCount(prevProps.patientDetail) === 1 &&
      getGamesCount(this.props.patientDetail) === 0 &&
      getQuestionnairesCount(this.props.patientDetail) !== 0
    ) {
      this.setState({ progressionEvaluationModalOpen: true })
    }

    this.handleFaultGames()
  }

  componentWillUnmount() {
    this.cleanLocationState()
    window.removeEventListener('beforeunload', this.cleanLocationState)
  }

  cleanLocationState = () => {
    const { state } = this.props.history.location

    if (state && typeof state === 'object') {
      if (state.userCameFromQuestionnaires) {
        delete state.userCameFromQuestionnaires
      }
    }
  }

  setOpen = (open: boolean): void => {
    this.setState({ modalOpen: open })
  }

  getGamesApp = (isUserLoggedinGame: boolean): void => {
    // const { patientDetail } = this.props
    if (isMobile && isUserLoggedinGame) {
      // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
      window.open(getDeviceLink())
    } else {
      this.setState({
        progressionEvaluationModalOpen: false,
        gameInstallationModalOpen: true
      })
    }
  }

  renderProgressionEvaluationModal() {
    const { patientDetail, history, user } = this.props
    const questionnairesCount = getQuestionnairesCount(patientDetail)
    const gamesCount = getGamesCount(patientDetail)

    return (
      this.state.progressionEvaluationModalOpen && (
        <ProgressionEvaluationModal
          age={getAge(patientDetail.birth_date)}
          open={this.state.progressionEvaluationModalOpen}
          questionnairesCount={questionnairesCount}
          gamesCount={gamesCount}
          showGames={true}
          showQuestionnaries={gamesCount === 0}
          history={history}
          onClose={() =>
            this.setState({ progressionEvaluationModalOpen: false })
          }
          onSubmit={() => {
            if (gamesCount === 0) {
              questionnairesCount > 0
                ? history.replace('/questionnaires', true)
                : // "back to abilities map" (questionnairesCount === 0)
                  history.push(_route.abilities(patientDetail.patientId))
            } else if (gamesCount > 0) {
              const {
                history: { location }
              } = this.props

              location.state = {
                ...location.state,
                fromModal: true
              }
              // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`

              return this.getGamesApp(user.logged_in_game)
            }
          }}
          relevantAssessment={patientDetail.assessments.relevant_assessment}
        />
      )
    )
  }

  renderGameInstallationModal() {
    const { user } = this.props
    const { gameInstallationModalOpen } = this.state

    return (
      <GameInstallationModal
        open={gameInstallationModalOpen}
        onClose={() => {
          this.setState({ gameInstallationModalOpen: false })
        }}
        user={user}
      />
    )
  }

  setEvaluationWarningModalOpen(evaluationWarningModalOpen: boolean): void {
    this.setState({ evaluationWarningModalOpen })
  }

  renderEvaluationWarningModal() {
    const { evaluationWarningModalOpen } = this.state
    const { PatientsLib, patientDetail } = this.props

    return (
      <EvaluationWarningModal
        active={evaluationWarningModalOpen}
        setActive={s => this.setEvaluationWarningModalOpen(s)}
        onButtonClick={() => {
          if (patientDetail) {
            const {
              patientId,
              assessments: { relevant_assessment }
            } = patientDetail

            PatientsLib.setCurrentAssessment(
              patientId,
              relevant_assessment,
              () => {
                PatientsLib.updateCurrentPatient()
                this.setEvaluationWarningModalOpen(false)
              },
              (error: string) => console.error(error)
            )
          } else {
            console.error('patientDetail is', { patientDetail })
          }
        }}
      />
    )
  }

  handleBtnClick = () => {
    const { patientDetail, user } = this.props

    if (
      patientDetail.currentAssessment !==
      patientDetail.assessments.relevant_assessment
    ) {
      this.setEvaluationWarningModalOpen(true)
      return
    }

    const gamesCount = getGamesCount(patientDetail)
    if (gamesCount === 0) {
      this.setState({ progressionEvaluationModalOpen: true })
    } else {
      this.getGamesApp(user.logged_in_game)
    }
    // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
  }

  handleCardClick = () => {
    const { history, patientDetail } = this.props

    if (
      patientDetail.currentAssessment !==
      patientDetail.assessments.relevant_assessment
    ) {
      this.setEvaluationWarningModalOpen(true)
      return
    }

    // because of freemium
    const isPlusUser = true
    const goToPlus = () => {
      history.push(_route.payment, { canGoBack: true })
    }

    isPlusUser
      ? this.setState({
          progressionEvaluationModalOpen: true
        })
      : goToPlus()
  }

  setActivePlusOnly = (status: boolean): void => {
    const { openPlusOnlyPopup, closePlusOnlyPopup } = this.props
    if (status) {
      openPlusOnlyPopup()
    } else {
      closePlusOnlyPopup()
    }
    // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
  }

  render() {
    const {
      games,
      goBackAction,
      faultGames,
      patientDetail,
      loading,
      instructionFaultGames,
      history,
      isOpenPlusOnlyPopup,
      openPlusOnlyPopup
    } = this.props
    const { modalOpen, isAccuracyFaultNotice } = this.state
    const gamesCount = getGamesCount(patientDetail)
    const patientFirstName = patientDetail?.first_name

    return (
      <div className="evaluation-games with-fixed">
        <div className="fixed-holder mui-fixed">
          <Header
            title={
              patientFirstName && childDashboardNameTransform(patientFirstName)
            }
            smallHeader={true}
            oneRow={true}
            type="color"
            goBackAction={goBackAction}
            defaultRightSide={true}
          />
          {!loading && <HeaderDetail openPlusOnlyPopup={openPlusOnlyPopup} />}
        </div>
        <PlusOnlyPopup
          open={isOpenPlusOnlyPopup}
          history={history}
          setActive={this.setActivePlusOnly}
        />
        {loading ? (
          <div
            style={{
              width: '100%',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Circle />
          </div>
        ) : (
          <div className="content">
            <div className="mobile-container heading">
              <Button
                id="start-game-tour-step"
                className={classnames('btn', 'btn-cta', {
                  'btn-cta--primary': gamesCount !== 0,
                  'btn-cta--secondary': gamesCount === 0
                })}
                onClick={this.handleBtnClick}
              >
                {gamesCount === 8
                  ? 'start games'
                  : gamesCount === 0
                  ? 'enter games'
                  : 'continue games'}
              </Button>
            </div>
            <div className="games-container">
              <div className="mobile-container games-grid">
                {games.map((g, i) => (
                  <GameBox
                    {...g}
                    key={i}
                    onClick={() => this.handleCardClick()}
                  />
                ))}
              </div>
              <div className="mobile-container fake-games-grid">
                <div className="cell">
                  <Button
                    className="start-tour-bnt"
                    onClick={() => TourService.startTour()}
                  >
                    TAKE TOUR
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
        <AccuracyFaultModal
          open={modalOpen}
          setOpen={this.setOpen}
          games={isAccuracyFaultNotice ? faultGames : instructionFaultGames}
          isAccuracyFaultNotice={isAccuracyFaultNotice}
        />
        {this.renderProgressionEvaluationModal()}
        {this.renderGameInstallationModal()}
        {this.renderEvaluationWarningModal()}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(Content)



// WEBPACK FOOTER //
// ./src/pages/EvaluationGames/content.tsx